import React from 'react';
import { useEffect, useState } from 'react';
import { Typography, Grid, Paper, Box } from '@mui/material';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from "react-i18next";

const useStyles = {
  infoContainer: {
    marginBottom: '16px',
    justifyContent: 'space-evenly',
  },
  element: {
    border: '2px solid #273497',
    borderRadius: 5,
    textAlign: 'center',
    marginBottom: '10px',
    backgroundColor: '#fff',
    // marginRight:2,
  },
  text: {
    color: '#273497',
  },
  subText: {
    color: '#5FB1F9',
    justifyContent: 'center',
  },
};

const DetailsPage = () => {
  const [data, setData] = useState([]);
  const [isloading, setIsloading] = useState(true);
  const location = useLocation();
  const { state } = location;
  const { id, type } = state;
  const classes = useStyles;
  const mashawiritoken = localStorage.getItem('mashawiritoken');
  const { t } = useTranslation();

  useEffect(() => {
    setIsloading(true);
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}trip_details`,
          {
            id,
            type,
          },
          {
            headers: {
              Authorization: `Bearer ${mashawiritoken}`,
            },
          }
        );
        setData(response.data.data);
        setIsloading(false);
      } catch (error) {
        console.error(error);
        setIsloading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <Box sx={{ bgcolor: '#EBF6FF', p: 5, borderRadius: 3 }}>
      <Grid container spacing={2} sx={classes.infoContainer}>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
          {t('Customer Number:')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {!isloading && data.clients && data.clients.map((element, index) => <div key={index}>{element.id} </div>)}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
          {t('Customer Name:')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.clients && data.clients.map((element, index) => <div key={index}>{element.name}</div>)}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Phone Number:')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.clients && data.clients.map((element, index) => <div key={index}>{element.phone}</div>)}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t("Region :")}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.clients && data.clients.map((element, index) => <div key={index}>{element.region} </div>)}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={classes.infoContainer}>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Driver Name:')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.driver_id}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Driver Number :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.driver_phone}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Car Type :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.cartype_id}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('City :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.city}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={classes.infoContainer}>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Source :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.source}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Distination :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.destination}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('The intended city :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.destination_city}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Time (Seconds) :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.time}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={classes.infoContainer}>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Distance (in meters) :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.distance}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Default distance (in meters) :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.default_distance}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
           {t('Default time (in seconds) :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.default_time}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Price per kilometer :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.km_price}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={classes.infoContainer}>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Minimum price :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.min_price}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Cash amount :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.cash}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Status :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.status}
          </Typography>
        </Grid>
        <Grid item xs={5} sx={classes.element}>
          <Typography variant="subtitle1" sx={classes.text}>
            {t('Creation date :')}
          </Typography>
          <Typography variant="body1" sx={classes.subText}>
            {isloading && <Skeleton sx={{ width: 80, margin: 'auto' }} />}
            {data.created_at}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetailsPage;
